import {
  getCountFromServer,
  QueryDocumentSnapshot,
  where,
} from "firebase/firestore";

import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
} from "firebase/firestore";

import { DEFAULT_PER_PAGE } from "../../components/Constants";
import { TProductDetail } from "../../types";
import { db } from "../firebaseConfig";

const dbName = "products";
const productsCol = collection(db, dbName);

export class ProductServices {
  static async getProducts(
    page: number = 1,
    lastVisibleDoc?: QueryDocumentSnapshot
  ) {
    try {
      let productQuery = query(
        productsCol,
        orderBy("createdDate", "desc"),
        limit(DEFAULT_PER_PAGE)
      );

      if (page > 1 && lastVisibleDoc) {
        productQuery = query(productQuery, startAfter(lastVisibleDoc));
      }

      const [productSnapshot, countSnapshot] = await Promise.all([
        getDocs(productQuery),
        getCountFromServer(productsCol),
      ]);

      const productList: TProductDetail[] = productSnapshot.docs.map((res) => ({
        ...res.data(),
      })) as TProductDetail[];

      const lastDoc = productSnapshot.docs[productSnapshot.docs.length - 1];
      const totalCount = countSnapshot.data().count;
      const hasNextPage = totalCount > page * DEFAULT_PER_PAGE;

      return { productList, lastDoc, hasNextPage };
    } catch (error) {
      console.error("Unable to fetch products from Firestore:", error);
      throw new Error("Unable to fetch products from Firestore");
    }
  }

  static async getProductDetail(code: string): Promise<TProductDetail | null> {
    try {
      const productsRef = collection(db, "products");
      const q = query(productsRef, where("code", "==", code));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const productDoc = querySnapshot.docs[0];
        return { id: productDoc.id, ...productDoc.data() } as TProductDetail;
      }
      return null;
    } catch (error) {
      throw new Error("Unable to retrieve product by code from Firestore.");
    }
  }
}
